module.exports = __webpack_public_path__ + "static/img/top-bgimg.f97d399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuzhou/top-bgimg.png
// module id = Ux1M
// module chunks = 1